import { useState } from 'react';
import { AssignYardsAndClientsModal } from '../../../design-system';
import { YardsPage, YardsHeader, YardsBody } from './YardsComponents';
import { RoleGuard } from '../../../routes';

export const Yards = () => {
  const [totalCount, setTotalCount] = useState(0);

  return (
    <RoleGuard roles={['SUPER_ADMIN']}>
      <YardsPage innerScroll>
        <YardsHeader totalCount={totalCount} />
        <YardsBody setTotalCount={setTotalCount} />
      </YardsPage>
      <AssignYardsAndClientsModal />
    </RoleGuard>
  );
};
